import Utils from "../../utils";

class GridHelper {
  static handlePageClick = (pageNumber, location, navigate) => {
    let queryParams = Utils.getQueryStringParams(location);

    // Convert from 0-based (Paging component) to 1-based (API)
    // Paging sends: 0, 1, 2... but API expects: 1, 2, 3...
    delete queryParams.current_page;
    queryParams.pageNumber = pageNumber + 1;

    GridHelper.refreshParams(queryParams, location, navigate);
  };

  static handleSortClick = (orderBy, orderDirection, location, navigate) => {
    let queryParams = Utils.getQueryStringParams(location);
    queryParams.order_by = orderBy;
    queryParams.order_direction = orderDirection;

    GridHelper.refreshParams(queryParams, location, navigate);
  };

  static handleSearch = (filter, location, navigate) => {
    let queryParams = Utils.getQueryStringParams(location);

    // Reset to first page when searching
    delete queryParams.current_page;
    queryParams.pageNumber = 1;

    for (const property in filter) {
      if (filter[property]) queryParams[property] = filter[property];
      else delete queryParams[property];
    }

    GridHelper.refreshParams(queryParams, location, navigate);
  };

  static refreshParams = (queryParamsObj, location, navigate) => {
    const currentPath = location.pathname;
    const newUrl = `${currentPath}?${Utils.objectToQueryString(queryParamsObj)}`;

    navigate(newUrl);
  };
}

export default GridHelper;
